module.exports = __webpack_public_path__ + "img/draft.2f0fc3bf.png";